export const RowsPerPageOptions = [10, 25, 50];